import React from "react";

//import PropTypes from 'prop-types';
import { themeService } from "../../../theme/service/activeTheme.service.js";

import { retroColors, electricColors } from "../../../style/basic/basicColors.js";

class MicrosoftRedirectPage extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { search, pathname } = window.location;
    const urlParams = new URLSearchParams(search);
    const microsoftGraphResponseToken = urlParams.get("msGraphResponse");
    const microsoftLoginError = urlParams.get("msLoginError");

    if (microsoftGraphResponseToken) {
      this.props.history.push(`/login?msGraphResponse=${microsoftGraphResponseToken}`);
    } else if (microsoftLoginError) {
      this.props.history.push(`/login?msLoginError=${microsoftLoginError}`);
    } else {
      // default error code
      this.props.history.push(`/login?msLoginError=${1}`);
    }
  }

  render() {
    return (
      <div className="App-container">
        
      </div>
    );
  }
}

export default MicrosoftRedirectPage;



// WEBPACK FOOTER //
// ./src/components/Login/MicrosoftRedirect/MicrosoftRedirectPage.jsx